import CheckIcon from '../../assets/icons/check.svg?react';
import './SelectAllCheckbox.css';

/**
 * SelectAllCheckbox 컴포넌트
 * 전체 선택/해제를 위한 체크박스 컴포넌트 (Gmail 스타일)
 * 
 * @param {Object} props
 * @param {'none' | 'partial' | 'all'} props.state - 체크박스 상태 ('none': 빈 상태, 'partial': 부분 선택, 'all': 전체 선택)
 * @param {Function} props.onClick - 체크박스 클릭 시 호출되는 함수
 * @param {boolean} props.disabled - 비활성화 여부
 * @param {string} props.className - 추가 CSS 클래스
 * @param {number} props.size - 체크박스 크기 (px, 기본값: 20)
 */
const SelectAllCheckbox = ({
  state = 'none',
  onClick = () => {},
  disabled = false,
  className = '',
  size = 20,
}) => {
  const handleClick = (e) => {
    if (disabled) return;
    e.stopPropagation();
    onClick();
  };

  return (
    <div
      className={`select-all-checkbox ${className} ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      {state === 'all' && (
        <div className="select-all-checkbox-icon">
          <CheckIcon width={size - 6} height={size - 6} color="#fff" />
        </div>
      )}
      {state === 'partial' && (
        <div className="select-all-checkbox-partial">
          <span className="select-all-checkbox-partial-line">−</span>
        </div>
      )}
      {state === 'none' && (
        <div className="select-all-checkbox-empty" />
      )}
    </div>
  );
};

export default SelectAllCheckbox;

